import {arrayOperatorsList} from './modules/array'
import {stringOperatorsList} from './modules/string'
import {booleanOperatorsList} from './modules/boolean'
import {dateOperatorsList} from './modules/date'
import {numberOperatorsList} from './modules/number'
// import './jsonLogicCustomOperations'

const operatorTypes = {
    [String.name]: stringOperatorsList,
    [Number.name]: numberOperatorsList,
    [Boolean.name]: booleanOperatorsList,
    [Array.name]: arrayOperatorsList,
    [Date.name]: dateOperatorsList
}

export default operatorTypes

export const getOperatorsListForDataType = (type) => {
    return operatorTypes[type] || operatorTypes[String.name]
}
